import React from "react";
import LegalLayout from "./LegalLayout";

export default function PrivacyPage() {
  return (
    <LegalLayout
      title="POLÍTICA DE PRIVACIDADE"
      subtitle="Como recolhemos, usamos e protegemos os teus dados pessoais — em conformidade com o RGPD (Regulamento (UE) 2016/679) e a Lei n.º 58/2019."
      lastUpdated="30 de dezembro de 2025"
    >
      <div className="border border-yellow-400/30 bg-yellow-400/5 p-5 text-sm text-zinc-200">
        <strong className="text-yellow-400">Compromisso:</strong> respeitamos a tua privacidade e
        tratamos os teus dados com transparência, segurança e apenas para as finalidades
        estritamente necessárias. Esta Política explica em linguagem clara os teus direitos e as
        nossas práticas.
      </div>

      <h2><span className="num">1.</span> Responsáveis pelo Tratamento</h2>
      <p>
        <strong>Produtor do conteúdo (controlador para dados do curso):</strong>
        <br />
        Kawan Oliveira — Kawan Gruista — Escola do Manobrador
        <br />
        Telefone / WhatsApp:{" "}
        <a href="https://wa.me/351963448484" target="_blank" rel="noopener noreferrer">
          +351 963 448 484
        </a>
        <br />
        Email:{" "}
        <a href="mailto:info@manobradordegruakawan.com">info@manobradordegruakawan.com</a>
      </p>
      <p>
        <strong>Plataforma de venda e pagamento (controlador autónomo para dados da compra):</strong>
        <br />
        Hotmart BV — Países Baixos. A Hotmart é a vendedora de registo, responsável pelo
        processamento de pagamento, emissão de fatura, gestão do acesso e reembolsos. Os seus
        tratamentos regem-se pela{" "}
        <a
          href="https://www.hotmart.com/pt-br/legal/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
        >
          Política de Privacidade da Hotmart
        </a>
        , que o Aluno aceita no momento da compra.
      </p>
      <p>
        Atualmente não é obrigatória a nomeação de um Encarregado de Proteção de Dados (DPO) nos
        termos do artigo 37.º do RGPD. Qualquer questão relativa aos teus dados no âmbito do
        Produtor deve ser dirigida ao email indicado.
      </p>

      <h2><span className="num">2.</span> Dados Pessoais Recolhidos</h2>
      <p>Podemos recolher e tratar as seguintes categorias de dados:</p>
      <ul>
        <li>
          <strong>Dados de identificação e contacto:</strong> nome completo, email, telefone (quando
          fornecido), país de residência.
        </li>
        <li>
          <strong>Dados de transação:</strong> data da compra, pacote adquirido, valor, método de
          pagamento (tratados exclusivamente pela Hotmart — não armazenamos dados de cartão).
        </li>
        <li>
          <strong>Dados de utilização da plataforma:</strong> aulas visualizadas, progresso,
          resultados da avaliação teórica (apenas no Pacote Completo).
        </li>
        <li>
          <strong>Dados técnicos:</strong> endereço IP, tipo de dispositivo, navegador, páginas
          visitadas, duração das sessões (via cookies e ferramentas analíticas).
        </li>
        <li>
          <strong>Comunicações:</strong> mensagens que nos envies por email, suporte ou formulários.
        </li>
      </ul>

      <h2><span className="num">3.</span> Finalidades e Fundamento Legal</h2>
      <p>
        Tratamos os teus dados apenas para finalidades específicas, com os fundamentos legais
        previstos no artigo 6.º do RGPD:
      </p>
      <ul>
        <li>
          <strong>Execução do contrato</strong> (art. 6.º, n.º 1, al. b)): criar e gerir o teu
          acesso ao curso, emitir certificação, prestar suporte técnico.
        </li>
        <li>
          <strong>Cumprimento de obrigação legal</strong> (al. c)): faturação, contabilidade,
          obrigações fiscais e registo formativo no SIGO / Passaporte Qualifica (Pacote Completo).
        </li>
        <li>
          <strong>Interesses legítimos</strong> (al. f)): segurança da plataforma, prevenção de
          fraude, melhoria do serviço, análise estatística agregada.
        </li>
        <li>
          <strong>Consentimento</strong> (al. a)): envio de comunicações de marketing, novas ofertas
          ou newsletter, apenas se tiveres dado consentimento expresso (podes retirar a qualquer
          momento).
        </li>
      </ul>

      <h2><span className="num">4.</span> Com Quem Partilhamos os Teus Dados</h2>
      <p>
        Os teus dados podem ser partilhados com as seguintes entidades, todas vinculadas por
        contrato e obrigações de confidencialidade:
      </p>
      <ul>
        <li>
          <strong>Hotmart (Hotmart BV):</strong> atua como <strong>controlador autónomo</strong>{" "}
          para os dados de compra, pagamento e emissão de fatura (vendedora de registo). É também a
          plataforma de alojamento do curso e da área de membros. Aplicam-se os termos e política
          de privacidade da Hotmart (
          <a href="https://www.hotmart.com/pt-br/legal" target="_blank" rel="noopener noreferrer">
            hotmart.com/legal
          </a>
          ).
        </li>
        <li>
          <strong>Entidade certificadora (CFOMP International / Escola do Manobrador):</strong>{" "}
          apenas para alunos do Pacote Completo, para efeitos de emissão de certificado SIGO e
          registo no Passaporte Qualifica.
        </li>
        <li>
          <strong>Prestadores de email e suporte</strong> (ex.: serviço de email transacional,
          helpdesk) com acordo de processamento de dados.
        </li>
        <li>
          <strong>Ferramentas analíticas</strong> (ex.: Google Analytics, Meta Pixel) — apenas com
          anonimização de IP e consentimento prévio, quando aplicável.
        </li>
        <li>
          <strong>Autoridades públicas</strong>, se e quando formos legalmente obrigados (ordens
          judiciais, fiscalização, etc.).
        </li>
      </ul>
      <p>
        <strong>Não vendemos</strong> os teus dados pessoais a terceiros para fins comerciais.
      </p>

      <h2><span className="num">5.</span> Transferências Internacionais</h2>
      <p>
        Alguns subcontratantes (como a Hotmart) podem processar dados em servidores localizados
        fora do Espaço Económico Europeu. Nestes casos, asseguramos que a transferência é feita
        ao abrigo dos mecanismos previstos nos artigos 44.º a 49.º do RGPD (cláusulas contratuais
        tipo aprovadas pela Comissão Europeia, decisões de adequação, etc.).
      </p>

      <h2><span className="num">6.</span> Prazos de Conservação</h2>
      <ul>
        <li>
          <strong>Dados de conta e acesso ao curso:</strong> durante o período de acesso (1 ano) +
          prazos legais residuais.
        </li>
        <li>
          <strong>Dados fiscais e de faturação:</strong> <strong>10 anos</strong>, nos termos do
          artigo 52.º do Código do IVA e artigo 123.º do Código do IRC.
        </li>
        <li>
          <strong>Registos de certificação SIGO:</strong> pelo prazo exigido pela legislação
          aplicável à entidade formadora certificada.
        </li>
        <li>
          <strong>Comunicações de marketing:</strong> até retirada do consentimento ou 3 anos após a
          última interação.
        </li>
        <li>
          <strong>Dados técnicos / logs:</strong> até 12 meses, para segurança e prevenção de
          fraude.
        </li>
      </ul>

      <h2><span className="num">7.</span> Os Teus Direitos (RGPD)</h2>
      <p>Nos termos dos artigos 15.º a 22.º do RGPD, tens os seguintes direitos:</p>
      <ul>
        <li><strong>Acesso</strong> aos teus dados pessoais e obtenção de uma cópia.</li>
        <li><strong>Retificação</strong> de dados incorretos ou desatualizados.</li>
        <li>
          <strong>Apagamento</strong> ("direito a ser esquecido"), nos casos legalmente previstos.
        </li>
        <li>
          <strong>Limitação</strong> do tratamento em situações específicas.
        </li>
        <li>
          <strong>Portabilidade</strong> dos dados para outro responsável, em formato estruturado.
        </li>
        <li>
          <strong>Oposição</strong> ao tratamento baseado em interesses legítimos ou para marketing
          direto.
        </li>
        <li>
          <strong>Retirada do consentimento</strong> a qualquer momento, sem afetar a licitude do
          tratamento efetuado até essa data.
        </li>
      </ul>
      <p>
        Para exercer estes direitos, envia um email para{" "}
        <a href="mailto:info@manobradordegruakawan.com">info@manobradordegruakawan.com</a> com o
        assunto "RGPD — Exercício de Direitos" e prova razoável da tua identidade. Respondemos no
        prazo máximo de 30 dias.
      </p>

      <h2><span className="num">8.</span> Reclamação à Autoridade de Controlo</h2>
      <p>
        Se entenderes que o tratamento dos teus dados viola o RGPD, tens o direito de apresentar
        reclamação à autoridade de controlo competente:
      </p>
      <p>
        <strong>Comissão Nacional de Proteção de Dados (CNPD)</strong>
        <br />
        Av. D. Carlos I, 134 — 1.º, 1200-651 Lisboa
        <br />
        Tel.: +351 213 928 400 · Email: geral@cnpd.pt
        <br />
        <a href="https://www.cnpd.pt" target="_blank" rel="noopener noreferrer">
          www.cnpd.pt
        </a>
      </p>

      <h2><span className="num">9.</span> Cookies e Tecnologias Semelhantes</h2>
      <p>
        Utilizamos cookies próprios e de terceiros para: (i) garantir o funcionamento da página
        (essenciais); (ii) medir estatisticamente a utilização; (iii) personalizar conteúdos e
        anúncios (apenas com consentimento).
      </p>
      <p>
        Na primeira visita, é apresentado um banner de consentimento. Podes gerir as tuas
        preferências a qualquer momento através das definições do teu navegador. Mais informação e
        controlo granular podem ser disponibilizados numa Política de Cookies dedicada quando
        aplicável.
      </p>

      <h2><span className="num">10.</span> Segurança</h2>
      <p>
        Aplicamos medidas técnicas e organizacionais adequadas (transmissões encriptadas via HTTPS,
        controlos de acesso, contratos de processamento com subcontratantes) para proteger os teus
        dados contra acesso não autorizado, perda, alteração ou divulgação indevida. Em caso de
        violação de dados com risco elevado para os teus direitos, cumpriremos as obrigações de
        notificação previstas nos artigos 33.º e 34.º do RGPD.
      </p>

      <h2><span className="num">11.</span> Menores</h2>
      <p>
        Os nossos serviços destinam-se a maiores de 18 anos ou, quando aplicável, a maiores de 16
        anos com autorização expressa dos representantes legais, conforme artigo 16.º do RGPD e
        artigo 7.º da Lei n.º 58/2019. Não recolhemos deliberadamente dados de menores sem o
        consentimento adequado.
      </p>

      <h2><span className="num">12.</span> Alterações a esta Política</h2>
      <p>
        Esta Política pode ser atualizada para refletir alterações legais, operacionais ou
        contratuais. As alterações relevantes serão comunicadas por email ou através de aviso
        destacado na página inicial, com antecedência razoável antes da entrada em vigor.
      </p>

      <h2><span className="num">13.</span> Contacto</h2>
      <p>
        Qualquer pedido, esclarecimento ou reclamação sobre proteção de dados:
        <br />
        <strong>WhatsApp / Telefone:</strong>{" "}
        <a href="https://wa.me/351963448484" target="_blank" rel="noopener noreferrer">
          +351 963 448 484
        </a>
        <br />
        <strong>Email:</strong>{" "}
        <a href="mailto:info@manobradordegruakawan.com">info@manobradordegruakawan.com</a>
      </p>
    </LegalLayout>
  );
}
